module.exports = __webpack_public_path__ + "img/topul.5b7eab34.png";